module.exports = __webpack_public_path__ + "static/img/ai.c2f29c4d.svg";